<ul class="hvac-segmented-control">
    <li *ngFor="let option of segmentedOptions$ | async"
    (click)="setOption(option)"
    [ngClass]="{ 'selected': getSelection(option) }" >
        {{ option.title }}
    </li>
</ul>
